<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    width="500"
    class="modal-legal"
  >
    <v-card>
      <v-card-title
        class="headline dark lighten-2 pb-4 justify-center"
        primary-title
      >
        Impressum
      </v-card-title>

      <v-card-text class="pt-5 dark white--text body-1 text-center">
        <p>Das holoWeb ist ein Angebot von <strong><a href="https://www.holonative.de" target="_blank" title="Zur Webseite">holoNative</a></strong>.</p>
        <p><strong>Verantwortlich:</strong>
          <br>
          Dennis Przytarski<br>
          Spichernstra&szlig;e 11<br>
          24116 Kiel
        </p>
        
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalLegal',
  props: { 
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>
